export class ExternalAssociation {
    public static EXTERNAL_SOURCE_ARENA: string = 'arena';
    public static EXTERNAL_SOURCE_TW: string = 'trackwrestling';
    public static EXTERNAL_SOURCE_SALESFORCE: string = 'salesforce';
    public static EXTERNAL_TYPE_EVENT: string = 'event';
    public externalSource: string;
    public externalId: string;
    public externalType: string;
    public arenaEventId: string;
    public createdAt: Date;
    public modifiedAt: Date;

    constructor() {}

    public serialize(): string {
        const body: any = {};
        body.type = this.externalType;
        body.id = this.externalId;
        body.source = this.externalSource;
        return JSON.stringify(body);
    }

    public deserialize(json: any): ExternalAssociation {
        const data: any = json.data || json;
        this.externalSource = data.external_source || data.externalSource;
        this.externalId = data.external_id || data.nodeId;
        this.externalType = data.external_type || data.externalType;
        this.createdAt = new Date(data.created_at);
        this.modifiedAt = new Date(data.modified_at);
        return this;
    }

    public isArenaLink(): boolean {
        return this.externalSource === ExternalAssociation.EXTERNAL_SOURCE_ARENA;
    }

    public isSalesforceLink(): boolean {
        return this.externalSource === ExternalAssociation.EXTERNAL_SOURCE_SALESFORCE;
    }
}
